import { useCallback } from 'react'
import type { apiClient } from '~/shared/api/data-ingestion-api'
import { useSubmitPatientMatch } from '../api'

export function useSubmitPatientMatchingNotes({ documentKey }: { documentKey: string }) {
  const { mutateAsync: addPatientMatchingReview, isPending, isSuccess } = useSubmitPatientMatch()

  const submitPatientMatchingNotes = useCallback(
    async (patientMatchingReview: apiClient.PatientCaseMatchingFeedbackRequest) => {
      await addPatientMatchingReview({
        path: {
          key: documentKey,
        },
        body: patientMatchingReview,
      })
    },
    [addPatientMatchingReview, documentKey],
  )

  return {
    submitPatientMatchingNotes,
    isPending,
    isSuccess,
  }
}
